module.exports = __webpack_public_path__ + "img/volunteer.361c24cc.png";